<div class="picture d-flex flex-fill align-items-center" [ngClass]="styleClasses" [appCssBackgroundImageProxy]="_box.PictureUrl" [ngStyle]="customStyle">
  <div [ngStyle]="getBannerBackGround()">
    <ng-container *ngIf="_box.Title && _box.ShowTitle" class="picture-infobox-ng-container">
      <h4 *ngIf="_box.Content && !isAreaHero" class="infobox-title font-weight-bold">
        {{_box.Title}}
      </h4>
      <!-- if only header, make it a bit larger as per design sketches -->
      <h3 *ngIf="!_box.Content && !isAreaHero" class="infobox-title font-weight-bold">
        {{_box.Title}}
      </h3>
      <!--If info box is top hero make header a lot bigger-->
      <h2 *ngIf="isAreaHero" class="infobox-title font-weight-bold">
        {{_box.Title}}
      </h2>
    </ng-container>

    <ng-container *ngIf="_box.Content" class="picture-infobox-ng-container-content">
      <p *ngIf="!isAreaHero" class="infobox-text"
         [innerHTML]="_box.Content">
      </p>
      <h3 *ngIf="isAreaHero" class="infobox-text h55"
          [innerHTML]="_box.Content">
      </h3>
    </ng-container>
  </div>

  <!-- Make whole box clickable -->
  <a *ngIf="_box.LinkUrl" class="font-weight-bold stretched-link picture-infobox-clickable-link" title="{{_box.LinkDescription}}" href="{{_box.LinkUrl}}">
    <span class="sr-only" i18n="@@read-more">Read more</span>
  </a>


</div>
